import { createAliasMapFromDownloads, replaceRootAlias } from '@remote/utils';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'PathNode',
  props: ['index', 'path'],
  emits: ['handleGetIn', 'handleDelete'],
  data() {
    return {};
  },
  computed: {
    title() {
      var _this$path;
      if (((_this$path = this.path) === null || _this$path === void 0 ? void 0 : _this$path.ParentID) === '') {
        var _this$$store$state$de, _this$$store$state;
        return replaceRootAlias({
          path: this.path.title,
          aliasMap: createAliasMapFromDownloads((_this$$store$state$de = (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 || (_this$$store$state = _this$$store$state.deviceInfoWatchData) === null || _this$$store$state === void 0 ? void 0 : _this$$store$state.downloads) !== null && _this$$store$state$de !== void 0 ? _this$$store$state$de : [])
        });
      }
      return this.path.title;
    }
  },
  methods: {
    async onClick() {
      this.$emit('handleGetIn', this.index);
    },
    onClose() {
      this.$emit('handleDelete', this.path);
    }
  }
});